<div class="view-images-carousel">
  <div tuiCarouselButtons class="view-images-carousel__wrapper">
    <button
      *ngIf="imageIds.length > 1"
      tuiIconButton
      class="view-images-carousel__btn view-images-carousel__btn_left"
      type="button"
      appearance="outline"
      iconStart="@tui.chevron-left"
      [size]="isDesktop ? 'm' : 's'"
      [disabled]="imageIds.length === 0"
      (click)="navigate(-1)"
    ></button>

    <tui-carousel
      [(index)]="selectedImgIndex"
      [draggable]="true"
      (indexChange)="changeImageIndex($event)"
      (touchmove)="touchmove()"
    >
      <ng-container *ngFor="let imageId of imageIds; let i = index">
        <ng-container *ngIf="downloadedPhotoIndexes.includes(i)">
          <div *tuiItem class="img-wrapper view-images-carousel__wrapper_img" [draggable]="false">
            <img alt="Product images" [src]="imageId | getImageSrc: 'Full image' : 'middleSize' : productUnionId" />
          </div>
        </ng-container>
      </ng-container>
    </tui-carousel>

    <button
      *ngIf="imageIds.length > 1"
      tuiIconButton
      class="view-images-carousel__btn view-images-carousel__btn_right"
      type="button"
      appearance="outline"
      iconStart="@tui.chevron-right"
      [size]="isDesktop ? 'm' : 's'"
      [disabled]="imageIds.length === 0"
      (click)="navigate(1)"
    ></button>

    <tui-pagination
      *ngIf="isMobile && imageIds.length > 1"
      class="view-images-carousel__wrapper_pagination"
      size="s"
      [length]="imageIds.length"
      [(index)]="selectedImgIndex"
    ></tui-pagination>
  </div>

  <div *ngIf="isDesktop && imageIds.length > 1" class="view-images-carousel__preview-wrapper">
    <tui-carousel [draggable]="true" [itemsCount]="maxImagesLength" [index]="carouselPreviewIndex">
      <ng-container *ngFor="let imageId of imageIds; let imageIndex = index">
        <img
          *tuiItem
          class="preview-item"
          alt="Product images"
          [class.preview-item_disabled]="imageIndex !== selectedImgIndex"
          [src]="imageId | getImageSrc: 'Preview image' : 'thumbnail' : productUnionId"
          [draggable]="false"
          (click)="changeImageIndex(imageIndex)"
        />
      </ng-container>
    </tui-carousel>
  </div>
</div>
